import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const rolesRequest = createAction(types.ROLES_REQUEST);
export const rolesSuccess = createAction(types.ROLES_SUCCESS);
export const rolesFailure = createAction(types.ROLES_FAILURE);

export const resourcesRequest = createAction(types.RESOURCES_REQUEST);
export const resourcesSuccess = createAction(types.RESOURCES_SUCCESS);
export const resourcesFailure = createAction(types.RESOURCES_FAILURE);

export const roleRequest = createAction(types.ROLE_REQUEST);
export const roleSuccess = createAction(types.ROLE_SUCCESS);
export const roleFailure = createAction(types.ROLE_FAILURE);

export const createRoleRequest = createAction(types.CREATE_ROLE_REQUEST);
export const createRoleSuccess = createAction(types.CREATE_ROLE_SUCCESS);
export const createRoleFailure = createAction(types.CREATE_ROLE_FAILURE);

export const updateRoleRequest = createAction(types.UPDATE_ROLE_REQUEST);
export const updateRoleSuccess = createAction(types.UPDATE_ROLE_SUCCESS);
export const updateRoleFailure = createAction(types.UPDATE_ROLE_FAILURE);

export const deleteRoleRequest = createAction(types.DELETE_ROLE_REQUEST);
export const deleteRoleSuccess = createAction(types.DELETE_ROLE_SUCCESS);
export const deleteRoleFailure = createAction(types.DELETE_ROLE_FAILURE);

export const resetRole = createAction(types.RESET_ROLE);

export default {
  resetRole,
  rolesRequest,
  rolesSuccess,
  rolesFailure,
  roleRequest,
  roleSuccess,
  roleFailure,
  resourcesRequest,
  resourcesSuccess,
  resourcesFailure,
  createRoleRequest,
  createRoleSuccess,
  createRoleFailure,
  updateRoleRequest,
  updateRoleSuccess,
  updateRoleFailure,
};
